(() => {
  const root = document.querySelector('[data-gift-shipping-progress]');
  if (!root) return;
  const fill = root.querySelector('[data-progress-fill]');
  const status = root.querySelector('[data-progress-status]');
  const giftMarker = root.querySelector('.sbz-progress__marker--gift');
  const shippingMarker = root.querySelector('.sbz-progress__marker--shipping');
  const giftLabel = root.querySelector('.sbz-progress__label--bottom.sbz-progress__label--gift');
  const shippingLabel = root.querySelector('.sbz-progress__label--bottom.sbz-progress__label--shipping');
  const track = root.querySelector('[role="progressbar"]');
  const shopCurrency = root.dataset.currency || 'EUR';
  const giftVariantId = Number(root.dataset.giftVariantId || 0);
  const shippingEligible = root.dataset.shippingEligible === 'true';
  const rootUrl = window.Shopify?.routes?.root || '/';
  const nativeFetch = window.fetch.bind(window);
  const giftThresholdShopCents = 3500;
  const shippingThresholdShopCents = 6000;
  let syncingGift = false;
  let refreshAgain = false;
  let refreshTimer = null;

  function presentmentRate() {
    const rate = Number(window.Shopify?.currency?.rate);
    return Number.isFinite(rate) && rate > 0 ? rate : 1;
  }

  function formatMoney(cents, currency) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: currency || shopCurrency,
      maximumFractionDigits: 2
    }).format(cents / 100);
  }

  function update(cart, rate) {
    const subtotal = Math.max(0, Number(cart.items_subtotal_price) || 0);
    const currency = cart.currency || shopCurrency;
    const giftThreshold = Math.round(giftThresholdShopCents * rate);
    const shippingThreshold = Math.round(shippingThresholdShopCents * rate);
    const maxThreshold = shippingEligible ? shippingThreshold : giftThreshold;
    const progress = Math.min(subtotal / maxThreshold, 1);

    root.classList.toggle('sbz-progress--gift-only', !shippingEligible);
    if (giftLabel) giftLabel.textContent = 'Geschenk ab ' + formatMoney(giftThreshold, currency);
    if (shippingLabel) shippingLabel.textContent = 'Gratis Versand ab ' + formatMoney(shippingThreshold, currency);
    if (shippingMarker) shippingMarker.hidden = !shippingEligible;
    if (shippingLabel) shippingLabel.hidden = !shippingEligible;

    fill.style.width = (progress * 100) + '%';
    track.setAttribute('aria-valuenow', String(Math.min(subtotal / 100, maxThreshold / 100)));
    track.setAttribute('aria-valuemax', String(maxThreshold / 100));
    track.setAttribute('aria-valuetext', formatMoney(subtotal, currency));
    giftMarker.classList.toggle('is-unlocked', subtotal >= giftThreshold);
    if (shippingMarker) shippingMarker.classList.toggle('is-unlocked', shippingEligible && subtotal >= shippingThreshold);

    if (subtotal >= giftThreshold) {
      status.textContent = shippingEligible && subtotal >= shippingThreshold
        ? '🎁 Dein Gratis Geschenk ist im Warenkorb – der Versand ist kostenlos.'
        : '🎁 Dein Gratis Geschenk wurde deinem Warenkorb hinzugefügt.';
    } else {
      status.textContent = 'Noch ' + formatMoney(giftThreshold - subtotal, currency) + ' bis zu deinem Geschenk.';
    }
  }

  async function syncGift(cart, giftThreshold) {
    if (!giftVariantId) return false;
    const giftLines = cart.items.filter(item => Number(item.variant_id) === giftVariantId);
    const eligible = Number(cart.items_subtotal_price) >= giftThreshold;
    if (!eligible && giftLines.length === 0) return false;

    if (!eligible) {
      await Promise.all(giftLines.map(item => nativeFetch(rootUrl + 'cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {Accept: 'application/json', 'Content-Type': 'application/json'},
        body: JSON.stringify({id: item.key, quantity: 0})
      })));
      return true;
    }

    if (giftLines.length === 0) {
      const response = await nativeFetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {Accept: 'application/json', 'Content-Type': 'application/json'},
        body: JSON.stringify({items: [{id: giftVariantId, quantity: 1}]})
      });
      return response.ok;
    }

    const changes = [];
    giftLines.forEach((item, index) => {
      const desiredQuantity = index === 0 ? 1 : 0;
      if (Number(item.quantity) !== desiredQuantity) {
        changes.push(nativeFetch(rootUrl + 'cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {Accept: 'application/json', 'Content-Type': 'application/json'},
          body: JSON.stringify({id: item.key, quantity: desiredQuantity})
        }));
      }
    });
    if (changes.length) {
      await Promise.all(changes);
      return true;
    }
    return false;
  }

  async function refreshCart() {
    if (syncingGift) {
      refreshAgain = true;
      return;
    }
    syncingGift = true;
    try {
      const response = await nativeFetch(rootUrl + 'cart.js', {
        credentials: 'same-origin',
        headers: {Accept: 'application/json'}
      });
      if (!response.ok) return;
      let cart = await response.json();
      const rate = presentmentRate();
      const giftThreshold = Math.round(giftThresholdShopCents * rate);
      update(cart, rate);
      const changed = await syncGift(cart, giftThreshold);
      if (changed) {
        const updatedResponse = await nativeFetch(rootUrl + 'cart.js', {
          credentials: 'same-origin',
          headers: {Accept: 'application/json'}
        });
        if (updatedResponse.ok) {
          cart = await updatedResponse.json();
          update(cart, rate);
        }
      }
    } catch (_) {
      // Keep storefront usable if the cart endpoint is temporarily unavailable.
    } finally {
      syncingGift = false;
      if (refreshAgain) {
        refreshAgain = false;
        window.setTimeout(refreshCart, 180);
      }
    }
  }

  function scheduleRefresh() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refreshCart, 900);
  }

  const originalFetch = window.fetch.bind(window);
  window.fetch = function(input, init) {
    const requestUrl = typeof input === 'string' ? input : (input && input.url) || '';
    return originalFetch(input, init).then(response => {
      try {
        const path = new URL(requestUrl, window.location.origin).pathname;
        if (/\/cart\/(add|change|update|clear)(\.js)?$/.test(path)) {
          scheduleRefresh();
        }
      } catch (_) {}
      return response;
    });
  };

  update({items_subtotal_price: root.dataset.subtotalCents, currency: shopCurrency}, presentmentRate());
  document.addEventListener('cart:updated', scheduleRefresh);
  document.addEventListener('cart:refresh', scheduleRefresh);
  refreshCart();
})();
